export default __webpack_public_path__ + "static/media/p7-4.9b7a4084.png";